var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-upload",
        {
          ref: "upload",
          staticStyle: { float: "left" },
          attrs: {
            disabled: _vm.disabled,
            action: _vm.uploadUrl,
            "show-file-list": false,
            multiple: "",
            "on-success": _vm.success,
            "on-remove": _vm.removeFile,
            name: "file",
          },
        },
        [
          _c(
            "el-button",
            {
              attrs: {
                slot: "trigger",
                disabled: _vm.disabled,
                size: "small",
                type: "primary",
              },
              slot: "trigger",
            },
            [_vm._v(_vm._s(_vm.$t("common.selectFile")))]
          ),
        ],
        1
      ),
      _c("div", { staticClass: "fileList" }, [
        _c(
          "ul",
          _vm._l(_vm.DocList, function (doc) {
            return _c(
              "li",
              [
                _c(
                  "el-link",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.downloadFile(doc)
                      },
                    },
                  },
                  [_vm._v(_vm._s(doc.documentName))]
                ),
                !_vm.disabled
                  ? _c("i", {
                      staticClass: "del-btn el-icon-delete pull-right",
                      on: {
                        click: function ($event) {
                          return _vm.removeFile(doc)
                        },
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          }),
          0
        ),
      ]),
      _c("div", { staticClass: "imgList" }, [
        _c(
          "ul",
          _vm._l(_vm.ImgList, function (img) {
            return _c("li", [
              _c(
                "div",
                { staticClass: "img-container" },
                [
                  _c("el-image", {
                    staticStyle: { width: "200px", height: "200px" },
                    attrs: {
                      src: img.base64 || _vm.docIdToUrl(img.tmDocumentId),
                      "preview-src-list": [
                        img.base64 || _vm.docIdToUrl(img.tmDocumentId),
                      ],
                    },
                  }),
                  _c(
                    "div",
                    { staticClass: "imgName" },
                    [
                      _c(
                        "el-link",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.downloadFile(img)
                            },
                          },
                        },
                        [_vm._v(_vm._s(img.documentName))]
                      ),
                      !_vm.disabled
                        ? _c("i", {
                            staticClass: "del-btn el-icon-delete pull-right",
                            on: {
                              click: function ($event) {
                                return _vm.removeFile(img)
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ])
          }),
          0
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }